import { tracking } from '@iwoca/frontend-tracking-library';
import { Link, SuccessMessage } from '@iwoca/orion';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { LayoutHeadings } from 'components/Layout/InnerLayout/LayoutHeadings/LayoutHeadings';
import { getAmplitudeDefaultEventProperties } from 'utils/amplitudeEvents';
import { ComparisonTable } from '../../ComparisonTable/ComparisonTable';
import sharedStyles from '../../Products.module.css';
import styles from './DocumentRequirementsDE.module.css';

export const DocumentRequirementsDE = () => {
  return (
    <div className={sharedStyles.section}>
      <LayoutHeadings
        heading={t`Required documents`}
        headingVariant="long"
        subHeading={t`Decisions on requests up to 50,000 € within hours`}
        headingAlignment="center"
      />

      <div className={styles.tableWrapper}>
        <ComparisonTable
          data={[
            {
              header: t`Bank statements`,
              smallBand: t`Last 90 days`,
              largeBand: t`Last 90 days`,
            },
            {
              header: 'BWA',
              smallBand: (
                <SuccessMessage className={styles.notRequired}>
                  <Trans>Not required</Trans>
                </SuccessMessage>
              ),
              largeBand: t`Current and last two financial years`,
            },
            {
              header: 'SuSa',
              smallBand: (
                <SuccessMessage className={styles.notRequired}>
                  <Trans>Not required</Trans>
                </SuccessMessage>
              ),
              largeBand: t`Current and last two financial years`,
            },
          ]}
          labels={{
            header: t`Loan amount`,
            smallBand: '1.000 - 50.000 €',
            largeBand: '50.001 - 500.000 €',
          }}
        />
      </div>

      <div className={styles.columnNotes}>
        <div />
        <div className={styles.columnNote}>
          <ul>
            <li>
              <Trans>
                Bank statements should be in PDF format, preferably downloaded
                directly from online banking.
              </Trans>
            </li>
            <li>
              <Trans>
                <strong>Tips</strong> for getting the statements right first
                time can be found{' '}
                <Link
                  className={styles.tipLink}
                  size="small"
                  href="https://support.iwoca.de/de/articles/12062223-kontoauszuge-tipps-damit-es-auf-anhieb-klappt"
                  target="_blank"
                  rel="noreferrer"
                  onClick={() =>
                    tracking.ampli.ctaClick({
                      ...getAmplitudeDefaultEventProperties(),
                      'CTA text': 'Bank statements support',
                    })
                  }
                >
                  here.
                </Link>
              </Trans>
            </li>
          </ul>
        </div>
        <div className={styles.columnNote}>
          <ul>
            <li>
              <Trans>The current BWA must not be older than 4 months.</Trans>
            </li>
            <li>
              <Trans>
                A <strong>year-end statement</strong>, <strong>P&amp;L</strong>{' '}
                or <strong>EÜR</strong> are accepted as alternatives to the BWA.
              </Trans>
            </li>
            <li>
              <Trans>
                For terms of 36, 48 and 60 months, the company must be
                profitable.
              </Trans>
            </li>
          </ul>
        </div>
        <div className={styles.columnNote}>
          <ul>
            <li>
              <Trans>The current SuSa must not be older than 4 months.</Trans>
            </li>
            <li>
              <Trans>
                A <strong>year-end statement</strong> or{' '}
                <strong>balance sheet</strong> are accepted as alternatives to
                the SuSa.
              </Trans>
            </li>
            <li>
              <Trans>
                <strong>Tips</strong> for getting the SuSa right first time can
                be found{' '}
                <Link
                  className={styles.tipLink}
                  size="small"
                  href="https://www.iwoca.de/kredit/datev-guide"
                  target="_blank"
                  rel="noreferrer"
                  onClick={() =>
                    tracking.ampli.ctaClick({
                      ...getAmplitudeDefaultEventProperties(),
                      'CTA text': 'SuSa support',
                    })
                  }
                >
                  here.
                </Link>
              </Trans>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};
